// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMediaAudioLoud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.331 19.743 8.73 16.257A1 1 0 0 0 8.06 16H4.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3.56a1 1 0 0 0 .67-.257l3.601-3.486C12.975 3.677 14 4.134 14 5v14c0 .866-1.025 1.323-1.669.743zm.169-1.866V6.123L9.733 8.858a2.5 2.5 0 0 1-1.672.642H5.5v5h2.56a2.5 2.5 0 0 1 1.673.642z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.265 11.987c0 1.93-.69 3.598-1.671 4.79l-.02.023c-.499.6-1.091 1.099-1.725 1.44a4.139 4.139 0 0 1-1.336.46c-.273.04-.498-.187-.498-.463v-.5c0-.198.116-.368.28-.474a.727.727 0 0 1 .214-.093c.185-.048.378-.122.575-.223.447-.229.91-.594 1.333-1.101l.019-.023c.768-.933 1.329-2.266 1.329-3.836 0-1.57-.56-2.902-1.33-3.835l-.01-.014c-.425-.512-.891-.88-1.341-1.11a2.838 2.838 0 0 0-.603-.231.745.745 0 0 1-.185-.086.573.573 0 0 1-.281-.474v-.5c0-.276.225-.503.498-.462a4.14 4.14 0 0 1 1.337.46 5.954 5.954 0 0 1 1.744 1.463c.981 1.192 1.67 2.86 1.67 4.79z"
    />
    <path
      fill="currentColor"
      d="M16.015 9.487c0-.276.231-.504.485-.397.202.086.396.22.574.397a2.686 2.686 0 0 1 .44.576c.305.52.5 1.192.5 1.924 0 .733-.195 1.404-.5 1.925a2.69 2.69 0 0 1-.44.575 1.855 1.855 0 0 1-.574.397c-.254.108-.485-.12-.485-.397z"
    />
  </svg>
);
export default SvgMediaAudioLoud;
